import React from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileIllustratedThree = ({
    clickNext = () => {},
    clickPrev = () => {},
                                     value
                            }) => {
  return (
    <div className="illustrated-three-mobile" data-model-id="16762:23252">
      <div className="frame-4">
        <div className="title">
          <p className="text-wrapper">Do you relate to the statement below?</p>
        </div>

        <div className="container">
          <Image src="/static/image/questionnaire/weight-loss/illustratedThree/illustration-3.png" alt="Illustration" className="illustration" />

          <p className="encouragement-text">
            I need encouragement or I might give up.
          </p>
        </div>
      </div>

      <div className="button-container">
          <button className={`label-wrapper ${value === "no" && "label-wrapper-select"}`} onClick={() => {clickNext("no")}}>
              <div className="label">No</div>
          </button>

          <button className={`label-wrapper ${value === "yes" && "label-wrapper-select"}`} onClick={() => {clickNext("yes")}}>
              <div className="label-2">Yes</div>
          </button>
      </div>
    </div>
  );
};
